/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { ObservableCollection$1 } from "igniteui-react-core";
import { Base, delegateCombine, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridSelectedItemsCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridSelectedItemsCollection, _super);
    function GridSelectedItemsCollection() {
        return _super.call(this, Base.$, 0) || this;
    }
    Object.defineProperty(GridSelectedItemsCollection.prototype, "ae", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    GridSelectedItemsCollection.prototype.af = function (a) {
        this.collectionChanged = delegateCombine(this.collectionChanged, a);
    };
    GridSelectedItemsCollection.$t = markType(GridSelectedItemsCollection, 'GridSelectedItemsCollection', ObservableCollection$1.$.specialize(Base.$));
    return GridSelectedItemsCollection;
}(ObservableCollection$1));
export { GridSelectedItemsCollection };
//# sourceMappingURL=GridSelectedItemsCollection.js.map
